// Hero Homepage - Rotating Text & Slider
document.addEventListener('DOMContentLoaded', function () {
  const heroSection = document.querySelector('[data-hero-section]');
  if (!heroSection) return;

  // === ROTATING TEXT FUNCTIONALITY ===
  const rotatingTextContainer = heroSection.querySelector('[data-rotating-text]');

  if (rotatingTextContainer) {
    const textItems = rotatingTextContainer.querySelectorAll('.rotating-text-item');
    const rotationSpeed = parseInt(heroSection.dataset.rotationSpeed) || 3000;
    let currentIndex = 0;

    // Only run rotation if there are multiple text items
    if (textItems.length > 1) {
      function rotateText() {
        // Remove active class from current item
        textItems[currentIndex].classList.remove('active');

        // Move to next item
        currentIndex = (currentIndex + 1) % textItems.length;

        // Add active class to next item
        textItems[currentIndex].classList.add('active');
      }

      // Start rotation
      setInterval(rotateText, rotationSpeed);
    }
  }

  // === EMAIL FORM FUNCTIONALITY ===
  const emailForm = heroSection.querySelector('[data-email-form]');
  const emailInput = heroSection.querySelector('[data-hero-email-input]');

  // Bot trap: honeypot + time-trap. Mirrors waitlist-form.liquid. Submits with
  // the honeypot filled, or fired within 1.5s of page load, are bot speed and
  // are silently dropped before any Klaviyo identify/track call.
  const formLoadTs = Date.now();
  function looksLikeBot() {
    try {
      const hp = emailForm ? emailForm.querySelector('input[name="bp_website"]') : null;
      if (hp && hp.value && hp.value.trim() !== '') return true;
      if (Date.now() - formLoadTs < 1500) return true;
      return false;
    } catch (_) {
      return false;
    }
  }

  if (emailForm) {
    emailForm.addEventListener('submit', function (e) {
      e.preventDefault();

      // Honeypot / time-trap: silently drop bot submits.
      if (looksLikeBot()) {
        try { emailForm.reset(); } catch (_) {}
        return;
      }

      const email = emailInput ? emailInput.value.trim() : '';

      // Clarity <-> Klaviyo identity link: tag this session with the email as
      // Clarity's Custom User ID. Runs independent of Klaviyo so it fires even
      // if Klaviyo is blocked. Strong signal (deliberate submit) -> persist.
      if (email && email.includes('@')) {
        try { if (window.brClarityIdentify) window.brClarityIdentify(email, true); } catch (error) {}
      }

      // Fire Klaviyo "Started Onboarding (General)" event
      if (email && typeof klaviyo !== 'undefined') {
        try {
          klaviyo.identify({ '$email': email });
          setTimeout(() => {
            try {
              klaviyo.track('Started Onboarding (General)', {
                '$email': email,
                form_location: 'hero-homepage',
                page_url: window.location.href,
                timestamp: new Date().toISOString()
              });
            } catch (error) {}
          }, 500);
        } catch (error) {}
      }

      // Open onboarding modal
      if (typeof window.openB2BOnboardingModal === 'function') {
        window.openB2BOnboardingModal();

        // Pre-populate email if provided
        if (email) {
          // Wait for modal to open and DOM to be ready
          setTimeout(() => {
            const onboardingEmailInput = document.querySelector('#b2bOnboardingModal input[type="email"], #b2bOnboardingModal input[name="email"]');

            if (onboardingEmailInput) {
              onboardingEmailInput.value = email;
              // Trigger input event for any listeners
              onboardingEmailInput.dispatchEvent(new Event('input', { bubbles: true }));
              onboardingEmailInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }, 300);
        }
      } else {
        console.warn('Onboarding modal function not found. Make sure the onboarding section is included on the page.');
      }
    });
  }

  // === SLIDER FUNCTIONALITY ===
  const sliderContainer = heroSection.querySelector('[data-hero-slider]');

  if (sliderContainer && typeof Swiper !== 'undefined') {
    const swiperEl = sliderContainer.querySelector('.swiper');
    const autoplaySpeed = parseInt(heroSection.dataset.autoplaySpeed) || 5000;

    const heroSwiper = new Swiper(swiperEl, {
      effect: 'coverflow',
      grabCursor: false,
      centeredSlides: true,
      loop: true,
      slidesPerView: 1.5,
      speed: 600,
      autoplay: {
        delay: autoplaySpeed,
      },
      mousewheel: {
        forceToAxis: true,
      },
      allowTouchMove: true,
      simulateTouch: true,
      breakpoints: {
        0: {
          slidesPerView: 1.3,
          spaceBetween: 12,
          coverflowEffect: {
            rotate: 0,
            stretch: -20,
            depth: 100,
            modifier: 2,
            slideShadows: false,
          },
        },
        749: {
          spaceBetween: 20
        },
        989: {
          slidesPerView: 1.4,
          spaceBetween: 50,
          coverflowEffect: {
            rotate: 0,
            stretch: -30,
            depth: 100,
            modifier: 2,
            slideShadows: false,
          },
        },
        1240: {
          slidesPerView: 1.5,
          spaceBetween: 50,
          coverflowEffect: {
            rotate: 0,
            stretch: -50,
            depth: 100,
            modifier: 2,
            slideShadows: false,
          },
        },
      },
      on: {
        afterInit: function () {
          // Wait 500ms after init, then fade in slider and background images
          setTimeout(() => {
            sliderContainer.classList.add('swiper-initialized');

            // Fade in background images
            const bgMobile = heroSection.querySelector('.hero-bg-mobile');
            const bgDesktop = heroSection.querySelector('.hero-bg-desktop');
            if (bgMobile) bgMobile.classList.add('loaded');
            if (bgDesktop) bgDesktop.classList.add('loaded');
          }, 500);
        },
      },
    });

  }

  // === PUBLIC HEADER SCROLL BEHAVIOR ===
  const publicHeader = document.querySelector('.public-header');

  if (publicHeader) {
    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset;

      // Add scrolled class when scrolled past 50px
      if (currentScroll > 50) {
        publicHeader.classList.add('scrolled-past-header');
      } else {
        publicHeader.classList.remove('scrolled-past-header');
      }
    });
  }
});
